export default __webpack_public_path__ + "static/media/setting.4efe4c33.svg";